function T1TableTextSearchInfo({ data }) {

    //console.log("TableDataBootstrap, data, isFetching", data);

    const columns = [
        { header: 'Nro', key: 'id', width: 23, visible: true },
        { header: 'Texto Buscado', key: 'text_search', width: 23, visible: true },
        { header: 'Cuenta', key: 'textSearchCount', width: 23, visible: true },
    ];

    return (
        <div>
            <div className="text-start">
                <strong>Tabla: SearchInfo, Cuenta Palabras buscadas por módulo:</strong>
            </div>
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead>
                        <tr className=''>
                            {data && data.length > 0 && columns && columns.length > 0 && (
                                columns.map((item, index) => {
                                    return (
                                        <th className=''>{item.header}</th>
                                    )
                                })
                            )}
                        </tr>
                    </thead>
                    <tbody>

                        {/* Start Table Body Columns */}
                        {data && data.length > 0 && (
                            data.map((item, index) => {
                                return (
                                    <tr key={index} className=''>

                                        <td className="list-table-cell-50"> {index+1} </td>
                                        <td className="list-table-cell-400"> {item.text_search} </td>
                                        <td className="list-table-cell-100"> {item.textSearchCount} </td>
                                    </tr>
                                )
                            })
                        )}
                        {/* End Table Body Columns */}

                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default T1TableTextSearchInfo